export default __webpack_public_path__ + "static/media/kosher.1946d013.svg";